"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginTopMessages = exports.getLoginMiddleMessages = exports.getDashboardTopMessages = exports.getDashboardMiddleMessages = exports.getDashboardBottomMessages = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _SecureClient = require("../SecureClient");
var _ApplicationContext = require("../ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getLoginMessages = location => {
  const siteId = _ApplicationContext.ApplicationContext.getSiteId() || '800000';
  const request = _axios.default.create({
    baseURL: _ApplicationContext.ApplicationContext.getApiBasePath()
  });
  return request.get(`/infrastructure/site/messaging/login/${location}/messages/get`, {
    headers: {
      siteId
    }
  });
};
const getAuthenticatedSiteMessages = type => {
  const secureClient = new _SecureClient.SecureClient();
  return secureClient.get(`/infrastructure/site/messaging/${type}/messages/get`);
};
const getDashboardTopMessages = () => {
  return getAuthenticatedSiteMessages('dashboard/top');
};
exports.getDashboardTopMessages = getDashboardTopMessages;
const getDashboardMiddleMessages = () => {
  return getAuthenticatedSiteMessages('dashboard/middle');
};
exports.getDashboardMiddleMessages = getDashboardMiddleMessages;
const getDashboardBottomMessages = () => {
  return getAuthenticatedSiteMessages('dashboard/bottom');
};
exports.getDashboardBottomMessages = getDashboardBottomMessages;
const getLoginTopMessages = () => {
  return getLoginMessages('top');
};
exports.getLoginTopMessages = getLoginTopMessages;
const getLoginMiddleMessages = () => {
  return getLoginMessages('middle');
};
exports.getLoginMiddleMessages = getLoginMiddleMessages;
//# sourceMappingURL=SiteMessaging.js.map